const IS_PROD_ENV = process.env.NODE_ENV === 'production';

const PIXEL_ID = '5HMmeuxTtnLKa1JiW9t6b1';
const SDK_URL = 'https://bzrcdn.openai.com/sdk/oaiq.min.js';

const CUSTOMER_ACTION_PROPS = { type: 'customer_action', amount: 0, currency: 'USD' } as const;

type OpenAiConversionEvent = 'registration_completed';

// Synchronous stub buffers calls in oaiq.q until the async SDK loads and replays them.
export const initOpenAiPixel = (): void => {
  if (!IS_PROD_ENV || typeof window === 'undefined' || window.oaiq) return;

  const queue: unknown[][] = [];
  const oaiq: OaiqFn = (...args: unknown[]) => {
    queue.push(args);
  };
  oaiq.q = queue;
  window.oaiq = oaiq;

  const script = document.createElement('script');
  script.async = true;
  script.src = SDK_URL;
  script.onerror = () => console.error(`Failed to load OpenAI Ads pixel SDK from ${SDK_URL}`);
  document.head.appendChild(script);

  window.oaiq('init', { pixelId: PIXEL_ID });
};

export const measureOpenAiConversion = (event: OpenAiConversionEvent): void => {
  if (!IS_PROD_ENV || typeof window === 'undefined') return;
  if (!window.oaiq) initOpenAiPixel();
  window.oaiq?.('measure', event, CUSTOMER_ACTION_PROPS);
};
